/**
 * UserAvatar — renders a user's profile photo when available, otherwise a
 * colored initials circle. Used across messaging / discussions / presence so
 * everyone shows their real avatar instead of just initials.
 */
import React from 'react';

function initialsOf(name) {
  const parts = (name || '').split(/\s+/).filter(Boolean);
  if (!parts.length) return 'U';
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
}

export default function UserAvatar({ name, src, size = 28, className = '', ring = '' }) {
  const style = { width: size, height: size };
  const base = `rounded-full flex-shrink-0 ${ring} ${className}`;
  if (src) {
    return <img src={src} alt={name || ''} style={style} className={`${base} object-cover`} data-testid="user-avatar-img" />;
  }
  return (
    <div style={style} className={`${base} bg-indigo-500/20 text-indigo-200 flex items-center justify-center font-medium`} data-testid="user-avatar-initials">
      <span style={{ fontSize: Math.max(9, Math.round(size * 0.4)) }}>{initialsOf(name)}</span>
    </div>
  );
}
